import { IQueryMediator, ICommand, IDefineCommand } from 'core-ts-types';
import { UnscheduledSectionsVisibilityModel } from '../models/unscheduled_sections_visibility_model';
import { UnscheduledSectionsQuery } from '../queries/unscheduled_sections_query';
import * as _4 from 'lodash4';
import { ICampusSectionGroup } from '../../../interfaces/scheduler_interfaces';
angular
  .module('capability-ng-scheduler')
  .service(
    'viewMoreTimesCommand',
    function viewMoreTimesCommand(
      defineCommand: IDefineCommand,
      ngUnscheduledSectionsQuery: UnscheduledSectionsQuery,
      ngUnscheduledSectionsVisibilityModel: UnscheduledSectionsVisibilityModel
    ) {
      'use strict';

      return defineCommand('viewMoreTimesCommand', (deferred: any, campus: ICampusSectionGroup) => {
        ngUnscheduledSectionsVisibilityModel.viewMoreTimes(campus);
        ngUnscheduledSectionsQuery.run();
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/unscheduled_sections/commands/view_more_times_command.ts